import {
    WHATSAPP_LIST_CONTATOS,
    WHATSAPP_LIST_CONTATOSLOADING,

    WHATSAPP_CONTATOPARC_INSERT,
    WHATSAPP_CONTATOPARC_INSERTLOADING,

    WHATSAPP_CONTATO_GERAL_LISTLOADING,
    WHATSAPP_CONTATO_GERAL_LIST,

    WHATSAPP_CONTATOPARC_UPDATELOADING,
    WHATSAPP_CONTATOPARC_UPDATE,

} from '../actions/ActionsTypes';

const INITIAL_STATE = {
    contatosList: [],
    contatosLoading: false,

    contatosListGeral: [],
    contatosGeralLoading: false,

    contatosParcUpdate: [],
    contatosParcUpdateLoader: false,

    contatosParcInsert: [],
    contatosParcInsertLoader: false,

    mensagem: "",
    status: "",
    codparc: ''
}

export default (state = INITIAL_STATE, action) => {


    switch (action.type) {

        case WHATSAPP_LIST_CONTATOS:
            return { ...state, contatosList: action.payload }

        case WHATSAPP_LIST_CONTATOSLOADING:
            return { ...state, contatosLoading: action.payload }

        case WHATSAPP_CONTATO_GERAL_LIST:
            return { ...state, contatosListGeral: action.payload }

        case WHATSAPP_CONTATO_GERAL_LISTLOADING:
            return { ...state, contatosGeralLoading: action.payload }
        
        case WHATSAPP_CONTATOPARC_INSERT:
            return { ...state, contatosParcInsert: action.payload }

        case WHATSAPP_CONTATOPARC_INSERTLOADING:
            return { ...state, contatosParcInsertLoader: action.payload }

        case WHATSAPP_CONTATOPARC_UPDATE:
            return { ...state, contatosParcUpdate: action.payload }

        case WHATSAPP_CONTATOPARC_UPDATELOADING:
            return { ...state, contatosParcUpdateLoader: action.payload }
            
        default:
            return state;
    }
}

